<template>
  <div class="ml-3 box">
    <br />
    <div class="box-100-no-centered">
      <div class="box-b-nombre-cliente">
        <div id="dtBasicExample_filter" class="dataTables_filter">
          <label>
            Buscar :
            <input
              type="search"
              class="form-control form-control-sm"
              placeholder
              aria-controls="dtBasicExample"
              v-model="clientSearch"
            />
          </label>
        </div>
      </div>
      <div class="box-ver-cliente">
        <div class="dataTables_length bs-select" id="dtBasicExample_length">
          <label>
            Ver
            <select
              name="dtBasicExample_length"
              aria-controls="dtBasicExample"
              class="custom-select custom-select-sm form-control form-control-sm"
              v-model="selectedValue"
              @change="onChange($event)"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </label>
        </div>
      </div>
      <div class="box-button-add-one">
        <!-- Using value -->
        <b-button class="mt-3" pill variant="primary" v-b-modal="'my-client-modal'">
           <b-icon icon="person"></b-icon> Agregar
          </b-button>
      </div>
    </div>
    <div class="box-100">
      <div class="box-table">
        <div class="overflow-auto">
          <b-pagination
            pills
            v-model="currentPage"
            :total-rows="getEntries"
            :per-page="selectedValue"
            aria-controls="my-table"
            size="md"
            align="center"
          ></b-pagination>

          <b-table
            show-empty
            small            
            head-variant="dark"
            id="my-table"
            :items="filteredClientList"
            :fields="fields"
            :per-page="selectedValue"
            :current-page="currentPage"
            :fixed="true"
            responsive
          >
            <template v-slot:cell(ACTIONS)="row">
              <!--client :client="row"/-->
              <b-button
                size="sm"
                class="mr-1"
                variant="warning"
                @click="info(row.item, $event.target)"
              >Edit</b-button>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-modal
      ref="my-client-modal"
      id="my-client-modal"
      hide-footer      
      :title="'Edición de Cliente'"
      centered
      ok-only
      @hide="resetInfoModal"
    >
      <ClientForm :client="$store.getters.getClientSelected" :update="$store.getters.getIsUpdate"></ClientForm>
    </b-modal>
    <div class="ml-3">
      <download-excel          
          class = "btn btn-success fill"
        :data="clientList"
        :columns="columns"
        :filename="'clientes ' + new Date()"
        :sheetname="'Clientes'"
      >Download</download-excel>
    </div>
  </div>
</template>

<script>
//import client from "./Client.vue";
import ClientForm from "./ClientForm.vue";
import { getAllClients } from "./../../api/conection";

export default {
  name: "clientListComponent",
  props: {
    clientList: {
      type: Array,
      default: []
    }
  },
  components: {
    //client,
    ClientForm
  },
  mounted() {
    getAllClients()
      .then(response => {
        if (response.status === 200) this.$store.dispatch("setClientsAction", response.body);
      })
      .catch(err => {
        console.log(err);
      });
  },
  computed: {
    filteredClientList() {
      const list = this.clientList.filter(cli => {
        return (
          cli.name.toLowerCase().includes(this.clientSearch.toLowerCase()) ||
          cli.username
            .toLowerCase()
            .includes(this.clientSearch.toLowerCase()) ||
          cli.email.toLowerCase().includes(this.clientSearch.toLowerCase())
        );
      });
      this.paginationLength = list.length;
      /*const init = Number(this.page) * Number(this.selectedValue);
      const final = Number(init) + Number(this.selectedValue);
      console.log("inicia: ", init, "termina: ", final);
      return list.slice(init, final);*/
      return list;
    },
    getEntries() {
      return this.paginationLength;
    },
    getPagination() {
      let result = Math.trunc(this.paginationLength / this.selectedValue);
      let resto = this.paginationLength % this.selectedValue;
      result = resto > 0 ? result + 1 : result;
      return this.getArrayPagination(0, 10, result);
    }
  },
  methods: {
    info(item, tittle, button) {
      this.$store.dispatch("selectClientAction", item);
      this.infoModal.title = tittle;
      //this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", "my-client-modal", button);
    },
    resetInfoModal() {
      this.$store.dispatch("unSelectClientAction", {});
    },
    setPage(page) {
      this.page = Number(page);
    },
    mostrar(value) {
      console.log(value);
    },
    onChange(event) {
      //console.log(event.target.value);
    },
    getArrayPagination(min, finish, length) {
      const result = [];
      for (let i = 1; i <= length; i++) {
        result.push(i);
      }
      return result.slice(min, finish);
    }
  },
  data() {
    return {
      clientSearch: "",
      selectedValue: 10,
      page: 0,
      paginationSet: 0,
      paginationLength: this.clientList.length,
      currentPage: 1,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      fields: [
        {
          key: "username",
          label: "Usuario"
        },
        {
          key: "name",
          label: "Nombre"
        },
        {
          key: "last_name",
          label: "Apellido"
        },
        {
          key: "email",
          label: "Email"
        },
        {
          key: "tel",
          label: "Tel"
        },
        {
          key: "bco",
          label: "Banco"
        },
        {
          key: "bco_account",
          label: "Cuenta Banco"
        },
        {
          key: "coin",
          label: "Moneda"
        },
        {
          key: "country",
          label: "Pais"
        },
        {
          key: "comentario",
          label: "Adicional"
        },
        "ACTIONS"
      ],
      columns: [
        {
          label: "Usuario",
          field: "username"
        },
        {
          label: "Nombre",
          field: "name"
        },
        {
          label: "Apellido",
          field: "last_name"
        },
        {
          label: "Email",
          field: "email"
        },
        {
          label: "Tel",
          field: "tel"
        },
        {
          label: "Banco",
          field: "bco"
        },
        {
          label: "Cuenta Banco",
          field: "bco_account"
        },
        {
          label: "Moneda",
          field: "coin"
        },
        {
          label: "Pais",
          field: "country"
        },
        {
          label: "Adicional",
          field: "comentario"
        }
      ]
    };
  }
};
</script>
<style>
/*
table.dataTable thead .sorting:after,
table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before {
  bottom: 0.5em;
}
*/
</style>